const VOLUME_STORAGE_KEY = "muzio-player-volume";
const DEFAULT_VOLUME = 0.5; // 50%

export const volumeStorage = {
  get() {
    try {
      const stored = localStorage.getItem(VOLUME_STORAGE_KEY);
      if (stored !== null) {
        const parsed = parseFloat(stored);
        // Validate: ensure 0-1 range
        if (!isNaN(parsed) && parsed >= 0 && parsed <= 1) {
          return parsed;
        }
      }
    } catch (error) {
      console.error('Error reading volume from localStorage:', error);
    }
    return DEFAULT_VOLUME;
  },

  set(volume) {
    try {
      // Validate and constrain
      const validated = Math.max(0, Math.min(1, parseFloat(volume) || DEFAULT_VOLUME));
      localStorage.setItem(VOLUME_STORAGE_KEY, validated.toString());
    } catch (error) {
      console.error('Error saving volume to localStorage:', error);
    }
  },

  clear() {
    try {
      localStorage.removeItem(VOLUME_STORAGE_KEY);
    } catch (error) {
      console.error('Error clearing volume from localStorage:', error);
    }
  }
};
